import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { initAuth, setupCrossTabLogoutListener } from '@/composables/useAuth'
import { logger } from '@/services/logger'
import './assets/main.css'

// Initialize Keycloak BEFORE installing the router and mounting the app.
// keycloak-js must process the OIDC redirect callback on the pristine URL; doing it
// lazily inside the router's beforeEach raced vue-router's `/`→`/tenants` redirect
// and the callback-hash cleanup, leaving onLoad:'login-required' in a redirect loop
// (code exchanged successfully, then login() fired again). In login-required mode an
// unauthenticated first load redirects to Keycloak here (mount never runs); on the
// callback load initAuth resolves and we mount with a settled session.
async function bootstrap(): Promise<void> {
  const app = createApp(App)
  app.use(createPinia())

  try {
    await initAuth()
  } catch (err) {
    // A hard init failure (e.g. Keycloak unreachable, blank realm) still mounts the
    // app; the router guard then sends the operator to the /error screen.
    logger.error('Keycloak initialization failed during bootstrap', err)
  }

  app.use(router)
  setupCrossTabLogoutListener()
  app.mount('#app')
}

void bootstrap()
